import React from 'react';


interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: any;
  value: any;
  bgWhite?:boolean
}

const TabPlane:React.FC<TabPanelProps> =props=>{
  const { children, value, bgWhite,index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
      className={`'custom-tabpanel' ${bgWhite?"bg-white":" border-none"}`}
    >
      {value === index && (
        <div className={`section-padding-2 ${bgWhite?"bg-white":"bg-primary border-none"}`}>
          {children}
        </div>
      )}
    </div>
  );
}
export default TabPlane;